import React, { memo, useCallback } from "react";
import { FilterType } from "./reportsUtils";

interface ReportsFilterProps {
  selectedFilter: FilterType;
  onFilterChange: (filter: FilterType) => void;
}

const ReportsFilter: React.FC<ReportsFilterProps> = memo(
  ({ selectedFilter, onFilterChange }) => {
    const handleFilterChange = useCallback(
      (filter: FilterType) => {
        onFilterChange(filter);
      },
      [onFilterChange]
    );

    return (
      <div className="reports-filter">
        <div className="filter-buttons">
          <button
            className={`filter-btn ${selectedFilter === "all" ? "active" : ""}`}
            onClick={() => handleFilterChange("all")}
          >
            All Reports
          </button>
          <button
            className={`filter-btn ${
              selectedFilter === "not-cleaned" ? "active" : ""
            }`}
            onClick={() => handleFilterChange("not-cleaned")}
          >
            Not Cleaned
          </button>
          <button
            className={`filter-btn ${
              selectedFilter === "cleaned" ? "active" : ""
            }`}
            onClick={() => handleFilterChange("cleaned")}
          >
            Cleaned
          </button>
        </div>
      </div>
    );
  }
);

ReportsFilter.displayName = "ReportsFilter";

export default ReportsFilter;
